// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lottie-spinner-overlay[data-v-f8c0685a] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n.lottie-spinner[data-v-f8c0685a] {\n  width: 128px;\n  height: 128px;\n}", ""]);
// Exports
module.exports = exports;
